<template>
    <AccountLayout :loading="loading" :isError=true>
        <div>
            <v-container id="loginMuMu">
                <v-row id="login-box" class="d-flex justify-center">
                    <v-col
                        class="pl-0 pr-0"
                        cols="12"
                        sm="auto"
                        md="auto"
                        style="display:flex; z-index: 1; justify-content: center;"
                    >
                        <div id="half-border">
                            <v-img
                                :src="require('../../assets/Group 92911.svg')"
                                contain
                                width="459"
                                height="462"
                                style="
                                    position: absolute;
                                    z-index: 1;
                                    margin-top: 2rem;
                                    margin-left: -13rem;
                                "
                            />
                        </div>
                        <v-card
                            width="540"
                            height="544px"
                            style="border-radius: 0px 30px 30px 0px"
                            elevation="0"
                        >
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <v-row class="mx-6">
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="text-center"
                                        >
                                            <div
                                                class="mt-7 prompt-title-500"
                                                style="
                                                    color: #255d98;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "message.loginPage.login"
                                                    )
                                                }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="pb-0">
                                            <div class="pa-0 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.email"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field
                                                dense
                                                outlined
                                                v-bind:placeholder="
                                                    $t(
                                                        'message.loginPage.fillEmail'
                                                    )
                                                "
                                                v-model="email"
                                                :rules="emailRules"
                                                type="email"
                                                required
                                                :error-messages="errorMessage"
                                            >
                                                <template
                                                    #message="{ message }"
                                                >
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="py-0">
                                            <div class="pa-0 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.password"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field
                                                dense
                                                outlined
                                                v-bind:placeholder="
                                                    $t(
                                                        'message.loginPage.passwordPlaceholder'
                                                    )
                                                "
                                                v-model="password"
                                                :append-icon="
                                                    showPass
                                                        ? 'mdi-eye'
                                                        : 'mdi-eye-off'
                                                "
                                                :rules="passwordRules"
                                                :type="
                                                    showPass
                                                        ? 'text'
                                                        : 'password'
                                                "
                                                @click:append="
                                                    showPass = !showPass
                                                "
                                                required
                                            >
                                                <template
                                                    #message="{ message }"
                                                >
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center pb-2 pt-0"
                                        >
                                            <a
                                                class="
                                                    prompt-underline
                                                    text-decoration-underline
                                                "
                                                href="/account/forget-password"
                                                style="color: #ff9800"
                                                >{{
                                                    $t(
                                                        "message.loginPage.forgetPassword"
                                                    )
                                                }}
                                            </a>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center py-2"
                                        >
                                            <v-btn
                                                class="prompt-24"
                                                :disabled="!valid"
                                                :color="
                                                    checkFill
                                                        ? '#FF9800'
                                                        : '#AFADB1'
                                                "
                                                @click="validate"
                                                rounded
                                                height="40"
                                                width="300"
                                                style="
                                                    font-weight: 400;
                                                    font-size: 18px;
                                                    line-height: 24px;
                                                    letter-spacing: 0.05rem;
                                                    color: #ffffff;
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "message.loginPage.login"
                                                    )
                                                }}
                                            </v-btn>
                                        </v-col>
                                        <v-col
                                            v-if="!timeout"
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center "
                                            style="margin-top: 6rem"
                                        >
                                            <div class="prompt-caption mr-2">
                                                {{
                                                    $t(
                                                        "message.loginPage.createNew"
                                                    )
                                                }}
                                            </div>
                                            <a
                                                class="
                                                    prompt-underline
                                                    text-decoration-underline
                                                "
                                                href="/register"
                                                style="color: #ff9800"
                                                >{{
                                                    $t(
                                                        "message.loginPage.register"
                                                    )
                                                }}
                                            </a>
                                        </v-col>
                                        <v-col
                                            v-else
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center"
                                            style="margin-top: 6rem"
                                        >
                                            <div class="prompt-caption mr-2">
                                                * {{ $t("message.loginPage.registerExpired")}}
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div id="orange-tab"></div>
        </div>
    </AccountLayout>
</template>

<script>
import AccountLayout from "@/components/common/AccountLayout";
import router from "@/router";
import * as services from "../../services";
import dayjs from 'dayjs';

export default {
    name: "LoginComp",
    components: { AccountLayout },
    data: () => ({
        valid: true,
        password: "",
        passwordRules: [
            (v) => !!v || "message.loginPage.leastLetters",
            (v) => v.length > 8 || "message.loginPage.leastLetters",
            (v) => /[a-zA-Z]/.test(v) && /\d/.test(v) || "message.loginPage.leastLetters",
        ],
        confirmPassword: "",
        showPass: false,
        showConfirmPass: false,

        email: "",
        checkbox: false,
        timeout: false,
        loading: 0,
        accountIsValid: 1,
        isError:true
    }),
    methods: {
        async validate() {
            const valid = this.$refs.form.validate();
            if (valid) {
                try{
                    const body = {
                        student_password: this.password,
                        register_form_link: localStorage.getItem("registerLink")
                    };
                    const res = await LoginAccount(body, this.email);
                    if (res.statusText == "OK") {
                        localStorage.setItem("token", res.data.data.token);
                        router.push({
                            path: "/form/1",
                        });
                    } else if (res.response.statusText == "Unauthorized") {
                        this.accountIsValid = 0;
                    } else if (res.response.statusText == "Not Found") {
                        this.accountIsValid = -1;
                    }
                }
                catch(err){
                    console.log(err);
                }
            }
        },
        compareDateIsBefore(from, to) {
            if (!from || !to) return true;
            if (dayjs(to).isSameOrBefore(dayjs(from))) return false;
            return true;
        },
        async checkRegisterFormTimeOut() {
            try {
                this.loading++;
                const { data } = await services.getRegisterFormIDFromLink({
                    link: localStorage.getItem("registerLink"),
                });
                if(data.status.code !== 405 || data.status.code !== 404){
                    if(data.data.timeout){
                        window.location.href = '/error'
                    }
                    let endDate = new Date(data.data.register_form_config?.closing_date);
                    endDate.setDate(endDate.getDate() + 1)
                    endDate = new Date(endDate.setHours(0))
                    this.timeout =  this.compareDateIsBefore(endDate, new Date());
                }
                else{
                    window.location.href = '/error'
                }
            } catch (err) {
                window.location.href = '/error'
            } finally {
                this.loading--;
            }
        },
    },
    computed: {
        checkFill() {
            const validate = this.$refs.form;
            const checkNull = this.email != "" && this.password != "";
            return validate?.value && checkNull;
        },
        emailRules() {
            return [
                (v) => !!v || "message.loginPage.fillEmail",
                (v) => /.+@.+\..+/.test(v) || "message.loginPage.incorrectEmail",
            ]
        },
        errorMessage() {
            // not found
            if(this.accountIsValid === -1)
                return ['message.loginPage.invalidUser']
            // invalid
            else if(this.accountIsValid === 0){
                return ['message.loginPage.passwordOrEmailInvalid']
            }
            else{
                return null
            }
        }
    },
    created() {
        localStorage.removeItem("token");
        this.checkRegisterFormTimeOut();
    },
    watch:{
        email(){
            if(this.accountIsValid != 1){
                this.accountIsValid = 1;
            }
        },
        password(){
            if(this.accountIsValid != 1){
                this.accountIsValid = 1;
            }
        }
    }
};



const LoginAccount = async (body, email) => {
    try {
        const res = await services.getLoginValidate(body, email);
        return res;
    } catch (error) {
        return error;
    }
};
</script>
